import { mapIndexed } from '../../../../../server/helpers/index.mjs';
import { RO_DISCLAIMER_NOTE } from './intervalsHelpers.js';

export const getReimbursementGraphContent = (healthInsurances = [], labelsRO = [], ROs = []) => {
  return {
    rows: mapIndexed((insurerAmount, index) => {
      return {
        label: labelsRO[index],
        columns: [
          {
            label: 'Assureur',
            value: parseFloat(insurerAmount) || 0
          },
          {
            label: 'Régime obligatoire',
            value: parseFloat(ROs[index]) || 0
          }
        ]
      };
    }, healthInsurances),
    note: RO_DISCLAIMER_NOTE
  };
};
